import Keycloak from 'keycloak-js'

const PROD_SSO = 'https://sso.myiris.gr'
const DEV_SSO = 'https://sso.fastmonkey.ovh'
const LOCAL_SSO = 'http://localhost:8080'

// const configure = () => window.location.host.includes('myiris') ? PROD_SSO : DEV_SSO

function configure() {
    let host = window.location.host;
    if(host.includes('myiris')) {
	return PROD_SSO;
    } else if(host.includes('fastmonkey')) {
	return DEV_SSO;
    }
    return LOCAL_SSO;
}

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'.
const keycloak = new Keycloak({
  url: `${configure()}/`,
  realm: 'iris',
  clientId: 'iris'
})

export default keycloak
